(function () {
  'use strict';

  document.querySelectorAll('[data-contact-page]').forEach(function (page) {
    var track = page.querySelector('[data-contact-reviews-track]');
    var previousButtons = Array.prototype.slice.call(page.querySelectorAll('[data-contact-reviews-prev]'));
    var nextButtons = Array.prototype.slice.call(page.querySelectorAll('[data-contact-reviews-next]'));
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function reviewDistance() {
      if (!track) return 336;
      var card = track.querySelector('.cooldo-contact-page__review');
      return card ? card.getBoundingClientRect().width + 16 : 336;
    }

    function updateReviewControls() {
      if (!track) return;
      var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      previousButtons.forEach(function (button) {
        button.disabled = track.scrollLeft <= 2;
      });
      nextButtons.forEach(function (button) {
        button.disabled = maximum <= 2 || track.scrollLeft >= maximum - 2;
        if (button.classList.contains('cooldo-contact-page__reviews-edge')) button.hidden = maximum <= 2;
      });
    }

    function moveReviews(direction) {
      if (!track) return;
      track.scrollBy({
        left: reviewDistance() * direction,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    previousButtons.forEach(function (button) {
      button.addEventListener('click', function () { moveReviews(-1); });
    });
    nextButtons.forEach(function (button) {
      button.addEventListener('click', function () { moveReviews(1); });
    });

    if (track) {
      track.addEventListener('scroll', updateReviewControls, { passive: true });
      window.addEventListener('resize', updateReviewControls);
      updateReviewControls();
    }

    page.querySelectorAll('[data-contact-chat]').forEach(function (button) {
      button.addEventListener('click', function () {
        function openChat() {
          var chat = document.querySelector('shopify-chat');
          if (!chat) return;
          if (typeof chat.open === 'function') {
            chat.open();
            return;
          }
          var activator = chat.shadowRoot && chat.shadowRoot.querySelector('button');
          if (activator) activator.click();
        }

        if (window.customElements && !window.customElements.get('shopify-chat')) {
          window.customElements.whenDefined('shopify-chat').then(openChat);
        } else {
          openChat();
        }
      });
    });
  });
})();
